/**
 * Redux internal
 */
import { selectors } from './_internal';

export default { ...selectors };
